// shopify-account（カスタマーアカウント）のメニューリンクをGA計測する。
// メニューは Shadow DOM 内に描画されるため Liquid で data 属性を付けられない。
// ホスト要素でクリックを受け、composedPath から実際の <a> を特定して計測する。

document.addEventListener('DOMContentLoaded', function () {
  // pathname からコンポーネント名を判定するルール（上から順にマッチ）
  const componentRules = [
    { match: '/account/orders', component: 'order_history' },
    { match: '/account/profile', component: 'profile' },
    { match: '/pages/my-coupon', component: 'coupon' },
    { match: '/pages/connect-filmarks', component: 'filmarks' },
  ];

  /**
   * pathname からコンポーネント名を判定する
   * @param {string} pathname - リンクの pathname
   * @returns {string | null} - マッチした component 名、なければ null
   */
  const resolveComponent = (pathname) => {
    const rule = componentRules.find((r) => pathname.includes(r.match));
    return rule ? rule.component : null;
  };

  document.querySelectorAll('shopify-account').forEach((account) => {
    account.addEventListener('click', function (event) {
      // Shadow DOM 内も含めてクリック経路から <a> を探す
      const link = event.composedPath().find((el) => el instanceof HTMLAnchorElement);
      // 開閉ボタン等（リンク以外）は従来どおり login 計測へ伝播させる
      if (!link) return;

      // メニューリンクは login と二重計上になるため、body の委譲リスナへ伝播させない
      event.stopPropagation();

      const component = resolveComponent(link.pathname);
      if (!component || !window.Shopify || !window.Shopify.analytics) return;

      window.Shopify.analytics.publish('custom_click', {
        module: 'account_menu',
        component: component,
      });
    });
  });
});
